import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import { User, DotationOperation, CustomerOrder, MultiChoiceGiftCard } from '@/models/index'

@Model()
export default class MultiChoiceCard extends ApplicationRecord {
  static jsonapiType = 'multi_choice_cards'

  @Attr() id!: string
  @Attr() amount!: number
  @Attr() remainingAmount!: number
  @Attr() expireAt!: string
  @Attr() usedAt!: string
  @Attr() createdAt!: string

  @BelongsTo() multiChoiceGiftCard!: MultiChoiceGiftCard
  @BelongsTo() dotationOperation!: DotationOperation
  @BelongsTo() customerOrder!: CustomerOrder
  @BelongsTo() customer!: User
}
